/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartPastHistoryAliases {
  AUTOCOMPLETE_SITUATION = 'autocomplete-situation',
  BUTTON_NEW_HISTORY = 'button-new-history',
  CONTEXTUAL_BAR_PAST_HISTORY_AREA = 'contextual-bar-past-history-area',
  DATE_FIELD_FROM_DATE = 'date-field-from-date',
  DATE_FIELD_UNTIL_DATE = 'date-field-until-date',
  DECK_HOSPITAL = 'deck-hospital',
  DECK_PATIENT = 'deck-patient',
  FETCH_HOSPITAL = 'fetch-hospital',
  FETCH_PAST_HISTORY_SITUATION = 'fetch-past-history-situation',
  FETCH_PATIENT = 'fetch-patient',
  FILTER_FIELD_FROM_DATE = 'filter-field-from-date',
  FILTER_FIELD_PAST_HISTORY_SITUATION = 'filter-field-past-history-situation',
  FILTER_FIELD_UNTIL_DATE = 'filter-field-until-date',
  FILTER_PAST_HISTORY_LIST = 'filter-past-history-list',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  HOSPITAL_CARD = 'hospital-card',
  LAYOUT_MY_CHART_PAST_HISTORY = 'layout-my-chart-past-history',
  MAPPER_SITUATION = 'mapper-situation',
  PANEL_PAST_HISTORY = 'panel-past-history',
  PATIENT_CARD = 'patient-card',
  TAB_CONTROL = 'tab-control',
  TAB_HOSPITAL = 'tab-hospital',
  TAB_PATIENT = 'tab-patient',
  TEXT_SITUATION = 'text-situation',
}
export { MyChartPastHistoryAliases };
